import { MFAStatus } from '~/repositories/UserRepository';

import { LoginAuthMethod } from './LoginAuthMethod';

export const shouldPromptMFASetup = (mfaStatus: MFAStatus, loginAuthMethod: LoginAuthMethod): boolean =>
  loginAuthMethod === LoginAuthMethod.PASSWORD && mfaStatus === MFAStatus.NOT_REQUIRED;
